import React from "react";
import CategoriesTable from "./CategoriesTable";
import ContentCard from "../../Common/Layout/ContentCard";
import Body from "../../Common/Body";

const Sellers = () => {
  return (
    <Body title={"Lista de categorías"}>
      <ContentCard>
        <CategoriesTable></CategoriesTable>
      </ContentCard>
    </Body>
  );
};

export default Sellers;
